"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var IcomoonReact_1 = require("./IcomoonReact/IcomoonReact");
var IcomoonReact_2 = require("./IcomoonReact/IcomoonReact");
Object.defineProperty(exports, "iconList", {
  enumerable: true,
  get: function () {
    return IcomoonReact_2.iconList;
  }
});
exports.default = IcomoonReact_1.IcomoonReact;